import React, { useState } from 'react'
import { useToast } from 'containers/ToastManager'
import ConfirmationDialog from 'components/ConfirmationDialog'
import { ModalInjectedProps } from 'containers/ModalManager'
import { useVersionUpdateKind } from 'modules/shares/operations'
import Checkbox from 'components/Checkbox'

export interface UnstarUpdateModalProps extends ModalInjectedProps {
  versionIdentifier: string
  isLibrary: boolean
}

export const UnstarUpdateModal = ({
  hideModal,
  isModalOpen,
  versionIdentifier,
  isLibrary,
}: UnstarUpdateModalProps) => {
  const { showToast } = useToast()
  const [skipModal, setSkipModal] = useState(false)

  const [versionKindUpdate, { loading }] = useVersionUpdateKind({
    onCompleted: () => {
      showToast('The Update has been unstarred')
      hideModal()
    },
    onError: message => showToast(message, 'negative'),
  })

  const handleSkipModal = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSkipModal(event.target.checked)
  }

  const onConfirm = () => {
    versionKindUpdate({ versionIdentifier, kind: 'DRAFT' })

    localStorage.setItem(
      'user:preferences:skipUnstarModal',
      JSON.stringify(skipModal)
    )
  }

  return (
    <ConfirmationDialog
      data-testid="create-star-update-modal"
      title={'Do you want to Unstar this Update?'}
      hideModal={hideModal}
      isModalOpen={isModalOpen}
      cancelButton={{ disabled: loading }}
      confirmButton={{
        variant: 'primary',
        text: 'Unstar Update',
        loading,
        disabled: loading,
      }}
      onConfirm={onConfirm}>
      {isLibrary ? (
        <p>
          If you remove a Star from a Library Update, anyone who uses your
          Library will receive changes from next most recent Starred Update. If
          there are no Starred Library Updates, they will receive changes from
          the most recent Library Update.
        </p>
      ) : (
        <p>
          If you remove a Star from an Update, external Viewers will see the
          next most recent Starred Update by default when they view your
          document. If there are no Starred Updates, they will see the most
          recent Update.
        </p>
      )}
      <Checkbox
        checked={skipModal}
        onChange={handleSkipModal}
        label="Don't ask me again"
      />
    </ConfirmationDialog>
  )
}
